import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {useParams} from 'react-router-dom';
import {ActiveSingleVoyageLazy} from '@containers/singleVoyage/activeVoyage/ActiveSingleVoyage.lazy';
import {useAppContext} from "@context/appContext/hooks/useAppContext";
import {
    useGetInitialAccountIdSingleVoyage
} from "@containers/singleVoyage/account/hooks/useGetInitialAccountIdSingleVoyage";

const ActiveSingleVoyagePage = () => {

    const {voyageId} = useParams()

    const accountId = useGetInitialAccountIdSingleVoyage()

    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ActiveSingleVoyageLazy
                    accountId={accountId}
                    voyageId={voyageId}
                />
            </Suspense>
        </PageLayout>
    );
};

export default ActiveSingleVoyagePage;